interface Params {
	isAccepted: boolean;
	awaitingPayment: boolean;
	rescheduleRequested?: boolean;
}

export function formatPurchaseStatus({
	isAccepted,
	awaitingPayment,
	rescheduleRequested
}: Params) {
	return rescheduleRequested
		? "Reschedule requested"
		: awaitingPayment
		? "Awaiting payment"
		: isAccepted
		? "Confirmed"
		: "Awaiting confirmation";
}
